import { useEffect } from 'react';

export default function GoogleAnalytics({ gaId, enabled }) {
  useEffect(() => {
    if (!enabled || !gaId) return;

    // Check if already loaded
    if (window.gtag) return;

    // Load gtag.js script
    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
    script.async = true;
    document.head.appendChild(script);

    // Initialize gtag
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', gaId, {
      page_title: document.title,
      page_location: window.location.href,
    });

    console.log('Google Analytics initialized:', gaId);

    return () => {
      // Cleanup if needed (though GA typically stays loaded)
    };
  }, [gaId, enabled]);

  return null;
}

// Helper function to track custom events
export function trackEvent(eventName, params = {}) {
  if (window.gtag) {
    window.gtag('event', eventName, params);
  }
}

// Helper function to track page views (for SPA navigation)
export function trackPageView(path, title) {
  if (window.gtag) {
    window.gtag('event', 'page_view', {
      page_path: path,
      page_title: title,
    });
  }
}
